import { RadioGroup } from '@/components/ui/radio-group';
import type { FavoriteListDto } from '@/services/platform/api/model';
import { WishlistRadioRow } from './WishlistRadioRow';

export interface WishlistRadioListProps {
  lists: FavoriteListDto[];
  /** Currently-selected `publicGuid` (controlled). */
  value: string | undefined;
  /** Fires immediately when the user taps a row (single-select commits on tap). */
  onValueChange: (publicGuid: string) => void;
  /** Fires when the user taps the already-selected row, removing the item from favorites. */
  onDeselect: (publicGuid: string) => void;
}

export function WishlistRadioList({ lists, value, onValueChange, onDeselect }: WishlistRadioListProps) {
  return (
    <RadioGroup value={value} onValueChange={onValueChange} className="flex flex-col gap-0 px-4">
      {lists.map(list => {
        const guid = list.publicGuid ?? '';
        const isSelected = guid !== '' && guid === value;
        return (
          <WishlistRadioRow
            key={guid}
            id={`wishlist-${guid}`}
            value={guid}
            label={list.name ?? ''}
            onDeselect={isSelected ? () => onDeselect(guid) : undefined}
          />
        );
      })}
    </RadioGroup>
  );
}
